// First-login AI Use Terms & human-review acknowledgment (clickwrap).
//
// IMPORTANT: bump TERMS_VERSION whenever the wording changes — every user is
// re-prompted to accept the new version (acceptance is recorded per version).
//
// LEGAL NOTE: this is the in-app acknowledgment that the AI requires human
// validation. The wording is a working draft and should be confirmed by
// counsel (Brazilian governing law + Florida/US review) before being treated
// as final. See vault: Juridico/Altelix Squad Finance - Vendor Protection
// Legal Study.md.

export const TERMS_VERSION = "1.0";
export const TERMS_EFFECTIVE = "2026-06-02";

export const TERMS_TITLE = "AI Use Terms & Human-Review Acknowledgment";

/** Short, scannable acknowledgments the user must read before accepting. */
export const TERMS_POINTS: { heading: string; body: string }[] = [
  {
    heading: "This system is AI-assisted decision support — not an autonomous decision-maker",
    body:
      "Squad Finance uses artificial intelligence to read statements and invoices, extract data, " +
      "categorize transactions, match documents, and prepare postings to QuickBooks. Its output is a " +
      "recommendation to help you work faster. It does not replace your professional judgment, and you " +
      "remain in control of every financial record.",
  },
  {
    heading: "AI can and does make mistakes",
    body:
      "AI output is probabilistic. It can misread a document (OCR errors), assign the wrong account, " +
      "match the wrong invoice, miss a transaction, or duplicate one. Confidence scores are estimates, " +
      "not guarantees. The system is provided on an “as-is” basis with no warranty of accuracy, " +
      "completeness, or fitness for a particular purpose.",
  },
  {
    heading: "You must review and validate before relying on any output",
    body:
      "You agree to review AI-generated results using the human-review surfaces provided (Review Queue, " +
      "Match Review, and the document viewers) and to approve them before relying on them — especially " +
      "before any accounting, tax, or financial decision. Anything posted to QuickBooks should be verified " +
      "against the source documents.",
  },
  {
    heading: "You are responsible for your financial records and source data",
    body:
      "You are responsible for the accuracy of your accounting records and tax filings, and for the quality " +
      "of the source documents you provide. The provider (4Clouders) is not responsible for outcomes that " +
      "result from unreviewed AI output or from inaccurate source data.",
  },
  {
    heading: "Your acceptance is recorded",
    body:
      "The date, time, your identity, and this version are recorded in the system audit trail as evidence " +
      "of this acknowledgment.",
  },
];

export const TERMS_ACCEPT_LABEL =
  "I understand the AI can make errors and that I am responsible for reviewing and validating its output before relying on it.";
